function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from 'react';
import cn from 'classnames';
import { FormControl, FormLabel } from 'react-bootstrap';
import T from 'prop-types';
import Icon from '../icon/Icon';
var Control = function(_param) {
    var isSuccessful = _param.isSuccessful, isInputWidthAuto = _param.isInputWidthAuto, label = _param.label, isFailed = _param.isFailed, validationError = _param.validationError, iconProps = _param.iconProps, required = _param.required, onMouseEnter = _param.onMouseEnter, className = _param.className, rest = _object_without_properties(_param, [
        "isSuccessful",
        "isInputWidthAuto",
        "label",
        "isFailed",
        "validationError",
        "iconProps",
        "required",
        "onMouseEnter",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: cn('Control', _define_property({}, className, className)),
        onMouseEnter: onMouseEnter
    }, label && /*#__PURE__*/ React.createElement(FormLabel, {
        className: "Control-Label"
    }, label, required && '*'), /*#__PURE__*/ React.createElement("div", {
        className: "Control-Container"
    }, /*#__PURE__*/ React.createElement(FormControl, _object_spread({
        className: cn('Control-Input', {
            isFailed: isFailed,
            hasIcon: (iconProps === null || iconProps === void 0 ? void 0 : iconProps.icon) || isSuccessful,
            'w-auto': isInputWidthAuto
        }),
        required: required
    }, rest)), /*#__PURE__*/ React.createElement(Icon, _object_spread({
        icon: cn(_define_property({
            confirm: isSuccessful
        }, iconProps === null || iconProps === void 0 ? void 0 : iconProps.icon, iconProps === null || iconProps === void 0 ? void 0 : iconProps.icon))
    }, iconProps))), /*#__PURE__*/ React.createElement("p", {
        className: cn('Control-Feedback', {
            isFailed: isFailed
        })
    }, validationError));
};
Control.propTypes = {
    isErroneous: T.bool,
    isSuccessful: T.bool,
    iconProps: T.shape(),
    isFailed: T.bool,
    label: T.string,
    validationError: T.string,
    validationSchema: T.shape(),
    required: T.bool,
    onMouseEnter: T.func
};
export default Control;
